module.exports = __webpack_public_path__ + "img/text_box.f6edaa1c.svg";